import { Component, Input } from '@angular/core';

import { NavigationItem } from '@cigna/chcp/shared/util';

@Component({
  selector: 'cigna-nav-item',
  templateUrl: './nav-item.component.html',
  styleUrls: ['./nav-item.component.scss'],
})
export class NavItemComponent {
  @Input() navItem: NavigationItem;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() topLevel = false;
  @Input() dataTestAttribute: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() impersonator = false;
}
